import type { AiCapabilityPage } from "../schema.js";
import { LIVE, OWNER_ADMIN } from "./_shared.js";

/**
 * `COL-SCHEDULE-MANAGE` (@UC0216) — trang **redirect** (US-AIV2-0049): chat KHÔNG hỏi ô, KHÔNG có nút Đồng ý,
 * chỉ một câu giải thích + nút mở đúng màn hình `/groups/:groupId/collections` (ADR-0009 bất biến 5).
 * US-AIV2-0110 S10 (`@UC0259`): trước trỏ trang chủ nhóm `/groups/:groupId`; nay tab "Quản lý quỹ" (danh sách đợt thu) — màn chi tiết đợt thu cần `collectionId` mà engine chưa điền được.
 * Cửa mobile trang này chịu trách nhiệm (bốn cửa lịch thu; cửa `POST .../collection-schedules` ĐÃ chuyển sang `COL-RECURRING` (0034b) — trang này giữ các cửa SỬA/DỪNG/BẬT LẠI lịch đã có).
 */
export const COL_SCHEDULE_MANAGE = {
  id: "COL-SCHEDULE-MANAGE",
  uc: "@UC0216",
  tier: "redirect",
  status: LIVE,
  roles: OWNER_ADMIN, // US-AIV2-tourguide-0008 (@UC0362 · review #1238 H1): thủ quỹ/thành viên KHÔNG thấy việc này ở màn đích (cờ app `canManageMembers` / sửa đợt = chủ nhóm + quản trị) ⇒ hẹp vai cho đúng app.
  flags: [],
  slots: [],
  llm: {
    description: "Quản lý một lịch thu định kỳ ĐANG CHẠY: dừng, chạy tiếp, hoặc xem kỳ kế. KHÔNG phải mở một lịch thu mới.",
    examples: [
      "lịch thu định kỳ",
      "lich thu dinh ky",
      "dừng thu hàng tháng",
      "dung thu hang thang",
      "bật lại lịch thu",
      "thu tự động",
      // ——— 0105: thêm cho đủ 40 ———
      "bat lai lich thu",
      "thu tu dong",
      "tạm dừng lịch thu định kỳ",
      "tam dung lich thu dinh ky",
      "kỳ thu tới là khi nào",
      "ky thu toi la khi nao",
      "tắt thu định kỳ đi",
      "tat thu dinh ky di",
      "cho lịch thu chạy tiếp",
      "cho lich thu chay tiep",
      "dừng lịch thu hàng quý lại",
      "dung lich thu hang quy lai",
      "xem lịch thu đang chạy",
      "xem lich thu dang chay",
      "lịch thu này còn chạy không",
      "lich thu nay con chay khong",
      "tháng sau khỏi thu tự động nữa",
      "thang sau khoi thu tu dong nua",
      "kích hoạt lại lịch thu đã dừng",
      "kich hoat lai lich thu da dung",
      "chỉnh lịch thu định kỳ",
      "chinh lich thu dinh ky",
      "hoãn lịch thu vài tháng",
      "hoan lich thu vai thang",
      "quản lý lịch thu",
      "quan ly lich thu",
      "lịch thu tự động của quỹ",
      "lich thu tu dong cua quy",
      "ngưng thu định kỳ",
      "ngung thu dinh ky",
      "bật lại thu hàng tháng cho nhóm",
      "bat lai thu hang thang cho nhom",
      "lịch thu định kỳ sắp tới thu bao nhiêu",
      "lich thu dinh ky sap toi thu bao nhieu",
    ],
  },
  screen: "/groups/:groupId/collections",
  screenShows: "collection_schedule",
  endpoints: [
    "POST /funds/{fundId}/collection-schedules/{scheduleId}/resume",
    "POST /funds/{fundId}/collections/{collectionId}/stop-schedule",
    "GET /funds/{fundId}/collection-schedules/{scheduleId}/reactivation-options",
  ],
  facts: [],
  templates: {
    redirect: "Mình mở màn hình quỹ để bạn xem và chỉnh lịch thu định kỳ nhé.",
  },
  journey: { after: ["READ-COLLECTIONS"] },
  help: { title: "Lịch thu định kỳ", tryNow: "lịch thu định kỳ" },
} satisfies AiCapabilityPage;
